import { ReactComponent as BrandLogo } from "../../clients/RACING/assets/logitech/logitechg (1).svg";
import { ReactComponent as MetaMap } from "../../clients/RACING/assets/Maple_Valley.svg";

export const LOGITECH_brandVariables = {
  client: "logitechg-7vvzz", // For picking wich leaderboard to show
  tenantId: "logitechg-7vvzz", // For picking wich leaderboard to show
  layoutKeyValue: "LOGITECH",
  brand: "logitech", // For scss
  gameStyle: "racing", // For picking wich leaderboard to show
  eventCode: "", // Needed for fetching correct challenge
  // eventCode: "logitech_gamebox_spring_2024", // Needed for fetching correct challenge
  challengeStatus: "ongoing",
  challengeGameType: "fm8",
  brandLogoType: "element", // "img" | "element" (svg)
  brandLogo: BrandLogo,
  leaderboardLength: 7,
  prize: {
    content: "win a",
    nameOf: "mclaren mp4/4 & ayrton senna", // will be marked in color
    typeOfItem: "", // will be added after nameOf
  },
  disclaimer: null,

  content: {
    generalHeadline: "Logitech g speed champions",
    generalHeadlineAlt: "Set the fastest time!",
    subHeadline: "Lorem ipsum...",
    overviewHeadline: "Dreamhack winter 2024 winners overview!",
    endscreenHeadline: "Thank you and congratulations to our",
  },

  metaInfo: {
    trackName: "Maple Valley (Short)",
    playerTeamOrCarValue: "mclaren mp4/4",
    playerTeamOrCarKey: "Car:",
    map: MetaMap,
    1: {
      key: "Turns:",
      value: "5",
    },
    2: {
      key: "Circuit length:",
      value: "1.85 km",
    },
    3: {
      key: "Track difficulty:",
      value: "very easy",
    },
    4: {
      key: "Lap record:",
      value: "00:34.731",
    },
  },
};
